module.exports = __webpack_public_path__ + "media/newstyle/images/card-icon-3-d012d307d90743591a971e88f819fee3.svg";